import Vue from 'vue'
import CorePlugin from '@/plugins'
import store from './store'
import App from '@/App.vue'
import router from '@/router'

Vue.use(CorePlugin)
// 创建事件总线
Vue.prototype.$bus = new Vue();
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
